const defaultState  = () => {
    return {
      branch:{
        id: null,
        name: null,
        phone: null,
        meta: null,
        direction: null,
      },
    }
  }
  const branch = {
    namespaced: true,
    state: defaultState(),
    mutations:{
      RESET_BRANCH:(state) => {
        Object.assign(state, defaultState())
      },
      SET_BRANCH: (state, connect) => {
        state.branch = {
          id: connect.id,
          name: connect.razon_social,
          celular: connect.telefono,
          meta: connect.meta_data,
          direction: connect.direccion,
        }
      },
    },
    actions:{
    },
  }
  
  export default branch